import { IsNotEmpty, IsString, IsDateString, IsUUID } from 'class-validator'
import { ApiProperty } from '@nestjs/swagger'

export class SchoolYearRefDto {
  @ApiProperty({
    description: "ID de l'année scolaire",
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({
    description: "Code de l'année scolaire",
    example: '2024-2025',
    type: 'string',
  })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({
    description: "Nom de l'année scolaire",
    example: 'Année 2024-2025',
    type: 'string',
  })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiProperty({ description: 'Date de début', example: '2024-09-01' })
  @IsNotEmpty()
  @IsDateString()
  startDate!: Date

  @ApiProperty({ description: 'Date de fin', example: '2025-07-31' })
  @IsNotEmpty()
  @IsDateString()
  endDate!: Date

  @ApiProperty({
    description: "Statut de l'année scolaire",
    enum: ['PLANNED', 'CURRENT', 'ARCHIVED'],
    example: 'CURRENT',
  })
  @IsNotEmpty()
  @IsString()
  status!: 'PLANNED' | 'CURRENT' | 'ARCHIVED'
}
